




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'

export enum ActiveInactiveStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

@Component
export default class ActiveInactiveStatusView extends Vue {
  @Prop({ required: true }) status!: ActiveInactiveStatus | boolean
  @Prop({
    default: () => ({
      active: 'فعال',
      inactive: 'غیرفعال'
    })
  }) statuses!: { [key in ActiveInactiveStatus]: string }

  get statusValue() {
    return (typeof this.status === 'boolean')
      ? (this.status === true) ? 'active' : 'inactive'
      : this.status
  }

  get statusColor() {
    switch (this.statusValue) {
      case ActiveInactiveStatus.ACTIVE:
        return 'text-green'
      case ActiveInactiveStatus.INACTIVE:
        return 'text-red'
      default:
        return ''
    }
  }
}
